/**
 * Predicate for the "user has no family yet" error case.
 *
 * The backend returns 404 with message starting with "No family found" from
 * /api/tasks, /api/circle, /api/families/mine, etc. The parent dashboard and
 * tasks page should render a welcoming first-run state instead of a hard
 * error when they hit this — a real network or 5xx error still surfaces.
 */
export function isNoFamilyError(err: unknown): boolean {
  if (!err) return false;
  const e = err as { response?: { status?: number; data?: { message?: string } } };
  if (e.response?.status !== 404) return false;
  const msg = e.response?.data?.message ?? '';
  return /no family/i.test(msg);
}
